<template>
    <div class="home-root">
        <Banner />
        <Features />
        <About />
    </div>
</template>

<script>
import Banner from './Banner.vue'
import Features from './Features.vue'
import About from './About.vue'
import { buildApiUrl } from '@/config/api'

export default {
    name: 'Home',
    components: {
        Banner,
        Features,
        About
    },
    mounted() {
        this.fetchMemberInfo()
    },
    methods: {
        async fetchMemberInfo() {
            const token = localStorage.getItem('token')
            if (!token) return

            try {
                const response = await fetch(buildApiUrl('/member/info'), {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                })

                if (!response.ok) return

                const data = await response.json()
                const memberInfo = data?.data || data || null
                if (memberInfo && typeof memberInfo === 'object') {
                    localStorage.setItem('memberInfo', JSON.stringify(memberInfo))
                    localStorage.setItem('userInfo', JSON.stringify(memberInfo))
                    localStorage.setItem('profile', JSON.stringify(memberInfo))
                }
            } catch (error) {
                console.error('Fetch member info error on Home:', error)
            }
        }
    }
}
</script>
<style scoped>
.home-root {
    position: relative;
    background-color: #fff;
    min-height: 100vh;
    z-index: 1; /* Establish stacking context for the pseudo-element */
}

.home-root::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    pointer-events: none;

    background-image: url('@/assets/home-bg1.png'), url('@/assets/home-bg2.png'), url('@/assets/home-bg3.png');
    background-size: 150%, 150%, 150%;
    background-position: 270px -700px, -1000px -900px, 0px 802px;
    background-repeat: no-repeat;

    /* 核心性能优化：强制开启 GPU 硬件加速，避免滚动时发生重绘（Repaint） */
    transform: translateZ(0);
    will-change: transform;
}

@media (max-width: 900px) {
    .home-root::before {
        background-image: url('@/assets/home-h5.png');
        background-size: 215%;
        background-position: -94px -267px;
        background-repeat: no-repeat;
    }
}
</style>
